
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLogoGeneric as ObiLogoGenericElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-logo-generic.js';
 
 
 

 
 export const ObiLogoGeneric = createComponent({
   react: React,
   tagName: 'obi-logo-generic',
   elementClass: ObiLogoGenericElement,
   events: {
     
   }
  });
 
 